export const IconBackspaceFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="m13.5 13.4 1.9 1.9a.95.95 0 0 0 .7.275.95.95 0 0 0 .7-.275.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7L14.9 12l1.9-1.9a.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275l-1.9 1.9-1.9-1.9a.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275.95.95 0 0 0-.275.7q0 .425.275.7l1.9 1.9-1.9 1.9a.95.95 0 0 0-.275.7q0 .425.275.7a.95.95 0 0 0 .7.275.95.95 0 0 0 .7-.275zm-6 6.6a1.99 1.99 0 0 1-1.6-.8l-4.5-6Q1 12.675 1 12t.4-1.2l4.5-6q.275-.375.7-.587Q7.025 4 7.5 4h13q.824 0 1.413.588.587.587.587 1.412v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20.5 20z" />
    </svg>
  );
};
